module.exports = __webpack_public_path__ + "static/junior-3-d1fa1d7e3702b71e7a435e6bbec7f7cf.jpg";